import apiClient, { setTokens, clearTokens, getRefreshToken } from './client'
import type { LoginRequest, LoginResponse, User } from '@/types'

export const authApi = {
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post<LoginResponse>('/auth/login', data)
    const { access_token, refresh_token } = response.data
    setTokens(access_token, refresh_token)
    return response.data
  },

  logout: async (): Promise<void> => {
    const refreshToken = getRefreshToken()
    if (refreshToken) {
      try {
        await apiClient.post('/auth/logout', { refresh_token: refreshToken })
      } catch {
        // Ignore errors on logout
      }
    }
    clearTokens()
  },

  getMe: async (): Promise<User> => {
    const response = await apiClient.get<User>('/auth/me')
    return response.data
  },
}
